import { BaseProvider } from "./base.provider";
import { BaseRequestStaticServer } from "../servers/base-request.server";
import { ResultType } from "../../models/common";
import { GreenLightTrend, GreenLightType, GreenLightContrast, LivingEnviType, HelpVillageType,
  ConstructionType,
  DeviceType,
  DeviceTypeData,
  DeviceDistributionCount,
  DeviceIndustrialPark,
  DeviceDistribution } from "../../models/village-screen";
import { ITable } from "@gago/frame";
// tslint:disable:ter-max-len

interface CodeParams {
  /** 区域代码 */
  code?: string;
  /** 获取年份 */
  lenYear?: string;
  /** 获取年份 */
  year?: string;
  /** 类型id数组 */
  types?: string;
}
interface ThingParams {
  /** 乡镇的code */
  code?: string;
  /** 产业园code */
  parkCode?: string;
  /** 设备code */
  deviceCode?: string;
}

export default class VillageScreenProvider extends BaseProvider {
  /** 资源概况 */
  static async getResourceType(params: CodeParams) {
    const { data } = await BaseRequestStaticServer.get<ResultType<GreenLightType>>("/green/light", { params });
    return data;
  }
  /** 获取绿光面积及夜光趋势数据 lenYear 获取年份 */
  static async getGreenLightTrend(params: CodeParams) {
    const { data } = await BaseRequestStaticServer.get<ResultType<GreenLightTrend[]>>("/green/light/trend", { params });
    return data;
  }
  /** 绿化面积及灯光数据各乡镇对比 year 获取年份 */
  static async getGreenLightContrast(params: CodeParams) {
    const { data } = await BaseRequestStaticServer.get<ResultType<GreenLightContrast[]>>("/green/light/contrast", { params });
    return data;
  }
  /** 农村人居环境 */
  static async getLivingEnvi(params: CodeParams): Promise<ITable<1, 1>> {
    const { data } = await BaseRequestStaticServer.get<ResultType<LivingEnviType>>("/living/envi", { params });
    return {
      title: "",
      subtitle: "总面积(万亩)",
      head: ["ID", "类型", "数量"],
      range: [[], [], []],
      prefix: ["", "", ""],
      suffix: ["", "", "个村"],
      defaultValue: [undefined, undefined, undefined],
      data: [
        ["", "健全村规民约、章程及村民理事会", data.villagersCouncil],
        ["", "三清三拆三整治", data.governance],
        ["", "村庄规划", data.planning],
        ["", "村道路面硬化", data.roadHardening],
        ["", "自然村村内道路硬化", data.roadHardeningInternal],
        ["", "集中供水", data.waterSupply],
        ["", "已建立垃圾收运处理体系", data.garbageDisposal],
        ["", "建有保洁队伍", data.cleanTeam],
        ["", "雨污分流管网建设", data.rainSewageShunt],
        ["", "污水处理设施", data.sewageTreatment],
      ],
    };
  }
  /** 获取万企帮村数据 */
  static async getHelpVillage(): Promise<ITable<1, 2>> {
    const { data } = await BaseRequestStaticServer.get<ResultType<HelpVillageType[]>>("/help/village", { });
    const tableData = data.map<ITable<1, 2>["data"][0]>(item => ["", item.name, item.money, item.beneficiary]);
    return {
      title: "",
      subtitle: "",
      head: ["ID", "类型", "金额", "人数"],
      range: [[], [], [], []],
      prefix: ["", "", "", ""],
      suffix: ["", "", "万元", "人"],
      defaultValue: [undefined, undefined, undefined, undefined],
      data: tableData,
    };
  }
  /** 省新农村连片示范建设 */
  static async getConstructionData(params: CodeParams): Promise<ITable<1, 1>> {
    const { data } = await BaseRequestStaticServer.get<ResultType<ConstructionType>>("/construction", { params });
    let allNum = data.central + data.province + data.city + data.county + data.social + data.crowd + data.other;
    allNum = Number(allNum.toFixed(1));
    return {
      title: `${allNum}`,
      subtitle: "总金额(万元)",
      head: ["ID", "类型", "金额"],
      range: [[], [], []],
      prefix: ["", "", ""],
      suffix: ["", "", "万元"],
      defaultValue: [undefined, undefined, undefined],
      data: [
        ["", "中央财政", data.central],
        ["", "省级财政", data.province],
        ["", "市级财政", data.city],
        ["", "县级财政", data.county],
        ["", "社会投入", data.social],
        ["", "群众自筹", data.crowd],
        ["", "其他", data.other],
      ],
    };
  }
  /** 获取物联网数据种类 */
  static async getDeviceType() {
    const { data } = await BaseRequestStaticServer.get<ResultType<DeviceType[]>>("/device/type", { });
    return data;
  }
  /** 获取对应传感器类型的数据 */
  static async getDeviceTypeData(params: CodeParams): Promise<ITable<2, 1>> {
    const { data } = await BaseRequestStaticServer.get<ResultType<DeviceTypeData[]>>("/device/type/data", { params });
    const tableData: ITable<2, 1>["data"] = [];
    let allNumber = 0;
    for (const iterator of data) {
      tableData.push(["", "设备", iterator.deviceName, iterator.amount]);
      allNumber += iterator.amount;
    }
    return {
      title: `${allNumber}`,
      subtitle: "",
      head: ["ID", "类型", "名称", "单位"],
      range: [[], [], [], []],
      prefix: ["", "", "", ""],
      suffix: ["", "", "", "台"],
      defaultValue: [undefined, undefined, undefined, undefined],
      data: tableData,
    };
  }
  /** 获取传感器分布 */
  static async getDeviceDistribution(params: ThingParams) {
    const { data } = await BaseRequestStaticServer.get<ResultType<(DeviceDistributionCount & DeviceIndustrialPark & DeviceDistribution)[]>>("/device/distribution", { params });
    return data;
  }
}
/**  获取绿光面积及夜光趋势数据 lenYear 获取年份 */
export function greenLightTrendITable(data: GreenLightTrend[], type?: string): ITable<2, 1> {
  if (type === "灯光辐射") {
    const tableData2 = data.map<ITable<2, 1>["data"][0]>(item => ["", "亮度", `${item.year}`, item.lightSum]);
    return {
      title: "",
      subtitle: "",
      head: ["ID", "类型", "年份", "单位"],
      range: [[], [], [], []],
      prefix: ["", "", "", ""],
      suffix: ["", "", "", "亩"],
      defaultValue: [undefined, undefined, undefined, undefined],
      data: tableData2,
    };
  }
  const tableData = data.map<ITable<2, 1>["data"][0]>(item => ["", "面积", `${item.year}`, item.greenArea]);
  return{
    title: "",
    subtitle: "",
    head: ["ID", "类型", "年份", "单位"],
    range: [[], [], [], []],
    prefix: ["", "", "", ""],
    suffix: ["", "", "", "万亩"],
    defaultValue: [undefined, undefined, undefined, undefined],
    data: tableData,
  };
}

/**  绿化面积及灯光数据各乡镇对比 year 获取年份 */
export function greenLightContrastITable(data: GreenLightContrast[], type?: string): ITable<2, 1> {
  if (type === "灯光辐射") {
    const tableData2 = data.map<ITable<2, 1>["data"][0]>(item => ["", "辐射比", `${item.name}`, item.lightSum]);
    return {
      title: "",
      subtitle: "",
      head: ["ID", "类型", "年份", "单位"],
      range: [[], [], [], []],
      prefix: ["", "", "", ""],
      suffix: ["", "", "", "%"],
      defaultValue: [undefined, undefined, undefined, undefined],
      data: tableData2,
    };
  }
  const tableData = data.map<ITable<2, 1>["data"][0]>(item => ["", "绿化率", `${item.name}`, item.greenRate]);
  return{
    title: "",
    subtitle: "",
    head: ["ID", "类型", "年份", "单位"],
    range: [[], [], [], []],
    prefix: ["", "", "", ""],
    suffix: ["", "", "", "%"],
    defaultValue: [undefined, undefined, undefined, undefined],
    data: tableData,
  };
}
